module.exports = __webpack_public_path__ + "assets/img/29_255.b2451631.jpg";